<template>
  <div class="text-xs-center">
    <img :src="image.url" class="img" height="150" v-if="image.url" />
    <v-text-field
      @click="pickFile"
      label="Seleccione un Adjunto"
      prepend-icon="attach_file"
      v-model="image.name"
      data-vv-name="attach_file"
    ></v-text-field>
    <input
      @change="onFilePicked"
      ref="image"
      style="display: none"
      type="file"
      data-vv-name="file"
    />
  </div>
</template>

<script>
export default {
  data: () => ({
    image: {
      url: '',
      name: '',
      file: '',
    },
  }),
  methods: {
    pickFile() {
      this.$refs.image.click()
    },
    onFilePicked(e) {
      const files = e.target.files
      const mainFile = files[0]
      if (mainFile !== undefined) {
        this.image.name = mainFile.name
        if (this.image.name.lastIndexOf('.') <= 0) {
          return
        }

        if (mainFile.type.match('image.*')) {
          /* Preview Image */
          const fr = new FileReader()
          fr.readAsDataURL(mainFile)
          fr.addEventListener('load', () => {
            if (fr.result) {
              this.image.url = fr.result
              this.image.file = mainFile // this is an image file that can be sent to server...
              this.$emit('clicked', mainFile)
            }
          })
        } else {
          this.image.url = ''
          this.image.file = mainFile // this is an image file that can be sent to server...
          this.$emit('clicked', mainFile)
        }
      } else {
        this.image = { url: '', name: '', file: '' }
        this.$emit('clicked', '')
      }
    },
  },
}
</script>
<style>
.img {
  max-width: 100%;
}
</style>
